import { useState, useEffect } from 'react';

export default function useIntersection(elRef, options) {
  const [isElementIntersected, setIsElementIntersected] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => {
      setIsElementIntersected(e.isIntersecting);
    }, options);

    elRef?.current && observer.observe(elRef?.current);

    return () => {
      elRef?.current && observer.unobserve(elRef?.current);
    };
  }, [elRef]);

  return [isElementIntersected];
}
